import type { BreakpointsOptions } from '@mui/material';

export const breakpoints: BreakpointsOptions = {
  values: {
    xs: 0,
    sm: 600,
    md: 900,
    lg: 1200,
    xl: 1536,
  },
};

/** Spacing base unit: 8px (MUI default) */
export const SPACING_UNIT = 8;
